function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
export var ModalContext = React.createContext({
  setDimensions: function setDimensions() {},
  decideFixedFooter: function decideFixedFooter() {},
  setHasModalSection: function setHasModalSection() {},
  removeHasModalSection: function removeHasModalSection() {},
  manageFocus: function manageFocus() {},
  hasModalSection: false,
  isMobileFullPage: false,
  isInsideModal: false
});
export var withModalContext = function withModalContext(Component) {
  return function (props) {
    return React.createElement(ModalContext.Consumer, null, function (contextProps) {
      return React.createElement(Component, _extends({}, props, contextProps));
    });
  };
};